import React from 'react';
import * as XLSX from 'xlsx';
import { BottomNavigationAction, Button } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { useTranslation } from 'react-i18next';
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';

function exportToExcel(data, fileName) {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Generate a binary string representation of the workbook
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Create a Blob from the binary string
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    // Create a link element
    const link = document.createElement('a');

    // Set the download attribute with the desired file name
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName}.xlsx`;

    // Append the link to the body
    document.body.appendChild(link);

    // Programmatically click the link to trigger the download
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);
}

function ExcelExport({ JsonData, ButtonType, ButtonText }) {
    const { t } = useTranslation('overview');
    if (!JsonData || JsonData.length === 0) {
        return (
            <>
                {
                    ButtonType === 1 ?
                        <BottomNavigationAction 
                            disabled={true} 
                            showLabel 
                            label={t('lblExport')} 
                            icon={<CloudDownloadIcon style={{color:'#AAC8A7'}} fontSize="large"/>} 
                        />
                        : ButtonType === 2 ?
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                disabled={true}
                                startIcon={<CloudDownloadOutlinedIcon />}
                            >
                                {t('lblExport')}
                            </Button>
                            : ButtonType === 3 ?
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    disabled={true}
                                    endIcon={<CloudDownloadIcon />}
                                >
                                    {t('lblDetailedExport')}
                                </Button> :
                                ButtonType === 4 ?
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    disabled={true}
                                    endIcon={<CloudDownloadIcon />}
                                >
                                    {t('lblExport')}
                                </Button> :
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={true}
                                    startIcon={<CloudDownloadOutlinedIcon />}
                                >
                                    {t('lblExport')}
                                </Button>
                }
            </>
        );
    }

    return (
        <>
            {
                ButtonType === 1 ?
                    <BottomNavigationAction 
                        showLabel 
                        label={t('lblExport')} 
                        icon={<CloudDownloadIcon style={{color:'#AAC8A7'}} fontSize="large"/>} 
                        onClick={() => exportToExcel(JsonData, 'ExportedData')}
                    />
                    : ButtonType === 2 ?
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<CloudDownloadOutlinedIcon />}
                            onClick={() => exportToExcel(JsonData, 'ExportedData')}
                        >
                            {t('lblExport')}
                        </Button>
                        : ButtonType === 3 ?
                            <Button
                                size="small"
                                variant="contained"
                                color="primary"
                                fullWidth
                                endIcon={<CloudDownloadIcon />}
                                onClick={() => exportToExcel(JsonData, 'ExportedData')}
                            >
                                {t('lblDetailedExport')}
                            </Button> :
                            ButtonType === 4 ?
                            <Button
                                size="small"
                                variant="contained"
                                color="primary"
                                fullWidth
                                endIcon={<CloudDownloadIcon />}
                                onClick={() => exportToExcel(JsonData, 'ExportedData')}
                            >
                                {t('lblExport')}
                            </Button> :
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<CloudDownloadOutlinedIcon />}
                                onClick={() => exportToExcel(JsonData, 'ExportedData')}
                            >
                                {t('lblExport')}
                            </Button>
            }
        </>
    );
}

export default ExcelExport;